// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#vue-wp-app .admin-nav{margin-bottom:20px;padding:10px 0;border-bottom:1px solid #ddd}#vue-wp-app .nav-link{margin-right:15px;padding:5px 10px;text-decoration:none;color:#444}#vue-wp-app .nav-link.router-link-active{color:#2271b1;font-weight:700}#vue-wp-app .default-view{padding:20px;margin:20px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
